"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetPaymentModelQuery = void 0;
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _i18n = require("@ori/i18n");
var _constantsGenerated = require("../constants-generated");
var _logger = require("../logger");
const fetchData = async (options)=>(0, _checkoutUtils.getUrl)(options);
const useGetPaymentModelQuery = (setActiveProviderId)=>{
    const { tenant } = (0, _environment.useEnvironment)();
    const { language } = (0, _i18n.useLanguage)();
    const { formattedToken } = (0, _auth.useToken)();
    const options = {
        applicationName: _constantsGenerated.APP_NAME,
        basePath: '/system/ajax/PaymentSelection/GetPaymentModel',
        currentLanguage: language,
        formattedToken,
        tenant
    };
    const { cacheKeys, urlOptions } = (0, _checkoutUtils.getUrlOptions)(options);
    const { data, error, isValidating, mutate } = (0, _fetching.useSWR)(cacheKeys, async ()=>fetchData(urlOptions), {
        ..._checkoutUtils.basicSwrOptions,
        onSuccess: (paymentModelData)=>{
            (0, _logger.logDebug)('useGetPaymentModelQuery() finished successfully');
            if (paymentModelData !== undefined) {
                setActiveProviderId(paymentModelData.selectedPaymentProviderId);
            }
        }
    });
    return {
        paymentModel: data,
        error,
        isPaymentModelLoading: isValidating,
        mutate
    };
};
exports.useGetPaymentModelQuery = useGetPaymentModelQuery;
